/**
 * Is this route the point-of-sale register?
 *
 * ONE definition, shared by both shells. Each of them used to carry its own copy
 * and the two had already drifted: TopNavShell matched `/pos` and `/sell`, while
 * Dashboard still matched ONLY the retired `/sell`. So the classic shell never
 * entered POS mode at all, and the two templates disagreed about what the same
 * screen was — which is how POS ended up navigable in one and a dead end in the
 * other. Anything that needs to ask this question imports it from here.
 *
 * `/sell` is kept because older builds and bookmarks still use it; the live route
 * is `/pos/*` (pages/routes/salesRoutes.js).
 */
export const isPosPath = (pathname) => {
  const path = pathname || "";
  return (
    path === "/pos" ||
    path.startsWith("/pos/") ||
    path === "/sell" ||
    path.startsWith("/sell/")
  );
};

export default isPosPath;
